import { render } from "./CenterModal.vue?vue&type=template&id=569de485"
import script from "./CenterModal.vue?vue&type=script&lang=js"
export * from "./CenterModal.vue?vue&type=script&lang=js"
script.render = render

export default script